<template>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <template v-for="(bci, idx) in bcItems">
        <li 
          :key="idx" 
          class="breadcrumb-item" 
          :class="{ 'active': idx == (bcItems.length - 1), 'text-primary': idx != (bcItems.length - 1)}">
          <a :href="bci.href">{{TranslateText(bci.text)}}</a>
        </li>
      </template>
    </ol>
  </nav>
</template>

<script>
  import { mapState } from 'vuex';
  import { mapGetters } from 'vuex';


  export default {
    computed: {
      ...mapState('permission', {
        bcItems: state => state.breadcrumbItems
        .map(i => ({
          text: i.name,
          href: i.url,
        })).reverse()
      }),
      ...mapGetters(['TranslateText']),

    }

  };
</script>



// WEBPACK FOOTER //
// src/components/BreadCrumb.vue